(() => {
    const questions = [
      { question: 'What best describes your cat’s personality?', answers: [
        { text: 'Curious, always watching', points: { ravenclaw: 3 } },
        { text: 'Not afraid of much', points: { gryffindor: 3, slytherin: 1 } },
        { text: 'Sweet when they feel like it', points: { hufflepuff: 3 } },
        { text: 'Confident and controlling', points: { slytherin: 3, gryffindor: 1 } }
      ]},
      { question: 'When something new shows up at home, how does your cat react?', answers: [
        { text: 'Studies it first before deciding', points: { ravenclaw: 3 } },
        { text: 'Stays close but always watching', points: { hufflepuff: 3, gryffindor: 1 } },
        { text: 'Walks right up like they own it', points: { gryffindor: 3 } },
        { text: 'Circles around and checks it on their terms', points: { slytherin: 3, ravenclaw: 1 } }
      ]},
      { question: 'What makes your cat happiest?', answers: [
        { text: 'Owning best spot in the house', points: { slytherin: 3 } },
        { text: 'Causing a scene, running, zooming, knocking things over', points: { gryffindor: 3 } },
        { text: 'Toys, boxes, and puzzles', points: { ravenclaw: 3 } },
        { text: 'Being near me', points: { hufflepuff: 3 } }
      ]},
      { question: 'Where does your cat feel most at home?', answers: [
        { text: 'A windowsill or perch with a great view', points: { ravenclaw: 3 } },
        { text: 'A spot near me and away from others', points: { hufflepuff: 3 } },
        { text: 'The highest place they can jump on', points: { slytherin: 3 } },
        { text: 'Anywhere they can run, jump, and explore', points: { gryffindor: 3 } }
      ]},
      { question: 'How do people usually describe your cat?', answers: [
        { text: 'Calm and cool', points: { hufflepuff: 3 } },
        { text: 'Dramatic and kinda crazy', points: { gryffindor: 3 } },
        { text: 'Smart and waiting to pounce', points: { ravenclaw: 3 } },
        { text: 'Strong-willed', points: { slytherin: 3 } }
      ]},
      { question: 'When guests come over, what does your cat usually do?', answers: [
        { text: 'Watches from a distance while judging', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Comes out for the right people', points: { hufflepuff: 3 } },
        { text: 'Runs into the room to eveluate', points: { gryffindor: 3 } },
        { text: 'Decides exactly who is worthy of attention', points: { slytherin: 3, gryffindor: 1 } }
      ]},
      { question: 'What trait is your cat known for?', answers: [
        { text: 'Being loving in quiet ways', points: { hufflepuff: 3 } },
        { text: 'Being clever and one step ahead', points: { slytherin: 3 } },
        { text: 'Being curious about everything', points: { ravenclaw: 3 } },
        { text: 'Being a little wild and adventurous', points: { gryffindor: 3 } }
      ]},
      { question: 'When your cat is playing, what stands out most?', answers: [
        { text: 'They wait and then pounce at the perfect time', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Total chaos and energy', points: { gryffindor: 3 } },
        { text: 'They get that toy no matter what', points: { slytherin: 3 } },
        { text: 'They expect me to always play with them', points: { hufflepuff: 3 } }
      ]},
      { question: 'What kind of activity would your cat enjoy most?', answers: [
        { text: 'Convincing me to keep them company', points: { hufflepuff: 3 } },
        { text: 'Puzzles, toys, treats, or anything I am now holding', points: { ravenclaw: 3 } },
        { text: 'Running and leaping at top speed, knocking things over', points: { gryffindor: 3 } },
        { text: 'Anything that ends with treats or praise', points: { slytherin: 3 } }
      ]},
      { question: 'When your cat sees something new, how do they react?', answers: [
        { text: 'Moves in fast with zero hesitation', points: { gryffindor: 3, hufflepuff: 1 } },
        { text: 'Studies it and then decides if it needs attention', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Stalks first and moves in slowly', points: { hufflepuff: 3, gryffindor: 1 } },
        { text: 'Pretends not to care, then investigates later', points: { slytherin: 3, ravenclaw: 1 } }
      ]},
      { question: 'Which saying fits your cat best?', answers: [
        { text: 'Loves anything new especially if I am holding it.', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Always wants the best seat, toy, or treat', points: { slytherin: 3 } },
        { text: 'Every hallway is an adventure, every plant needs to be destroyed', points: { gryffindor: 3 } },
        { text: 'They act aloof, but always by my side', points: { hufflepuff: 3 } }
      ]},
      { question: 'Which choice sounds most like your cat?', answers: [
        { text: 'Demands to know what is behind every door', points: { ravenclaw: 3 } },
        { text: 'Leaps first no matter how many times I say NOOOO', points: { gryffindor: 3 } },
        { text: 'Loves on their terms and at their designated time', points: { hufflepuff: 3 } },
        { text: 'Knows who runs the house, and it is never me', points: { slytherin: 3 } }
      ]}
    ];

    const houseResults = {
      gryffindor: {
        name: 'Gryffindor',
        description: 'Your cat is bold, fearless, and full of main-character energy. They leap first, explore fast, and somehow make every hallway feel like an adventure.',
        secondary: 'Fearless, Dramatic, and Adventurous',
        resultTitle: 'Your cat is a Gryffindor! The fearless troublemaker.',
        bundleHeading: 'Gryffindor cat picks',
        bundleIntro: 'Perfect for brave cats with zoomies, confidence, and a little dramatic flair.',
        bundleItems: [
          { title: 'Gryffindor Cat Accessories', description: 'A bold house look for your fearless feline.', url: '/search?q=gryffindor+cat' },
          { title: 'Gryffindor Pet Accessories', description: 'House-inspired finds with red-and-gold energy.', url: '/search?q=gryffindor+pet' }
        ]
      },
      ravenclaw: {
        name: 'Ravenclaw',
        description: 'Your cat is smart, observant, and always paying attention. They notice everything, study first, and seem to know more than they let on.',
        secondary: 'Clever, Curious, and Observant',
        resultTitle: 'Your cat is a Ravenclaw! The curious mastermind.',
        bundleHeading: 'Ravenclaw cat picks',
        bundleIntro: 'Made for curious cats who inspect every shelf, box, and mysterious sound.',
        bundleItems: [
          { title: 'Ravenclaw Cat Accessories', description: 'A smart-looking house style for your observant cat.', url: '/search?q=ravenclaw+cat' },
          { title: 'Ravenclaw Pet Accessories', description: 'Blue-and-bronze-inspired picks for thoughtful felines.', url: '/search?q=ravenclaw+pet' }
        ]
      },
      hufflepuff: {
        name: 'Hufflepuff',
        description: 'Your cat is loving, gentle, and quietly loyal. They may not demand attention all day, but they stay close to the people they trust most.',
        secondary: 'Sweet, Loyal, and Comforting',
        resultTitle: 'Your cat is a Hufflepuff! The loyal softie.',
        bundleHeading: 'Hufflepuff cat picks',
        bundleIntro: 'Great for sweet cats who love cozy naps, calm affection, and quiet companionship.',
        bundleItems: [
          { title: 'Hufflepuff Cat Accessories', description: 'A warm house look for the gentlest whiskers in the room.', url: '/search?q=hufflepuff+cat' },
          { title: 'Hufflepuff Pet Accessories', description: 'Friendly, warm-toned finds for affectionate cats.', url: '/search?q=hufflepuff+pet' }
        ]
      },
      slytherin: {
        name: 'Slytherin',
        description: 'Your cat is confident, strategic, and absolutely in charge. They know the best seat, the best timing, and exactly how to get what they want.',
        secondary: 'Confident, Strategic, and Commanding',
        resultTitle: 'Your cat is a Slytherin! The elegant ruler.',
        bundleHeading: 'Slytherin cat picks',
        bundleIntro: 'Ideal for cats with attitude, strategy, and a clear understanding that they run the house.',
        bundleItems: [
          { title: 'Slytherin Cat Accessories', description: 'A sharp green-and-silver style for commanding cats.', url: '/search?q=slytherin+cat' },
          { title: 'Slytherin Pet Accessories', description: 'House-inspired pieces for strong-willed companions.', url: '/search?q=slytherin+pet' }
        ]
      }
    };

    const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '');
    const sanitizeTagPart = (value) => (value || '').toString().trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

    function initSortingSection(section) {
      if (!section || section.dataset.sortingInitialized === 'true') return;
      section.dataset.sortingInitialized = 'true';

      const configScript = section.querySelector('[data-sorting-config]');
      if (!configScript) return;

      let config = { collectionUrls: {}, resultImageUrls: {} };
      try {
        config = JSON.parse(configScript.textContent);
      } catch (e) {
        console.error('Sorting Hat config parse error', e);
      }

      const stepEls = {
        age: section.querySelector('[data-step="age"]'),
        under13: section.querySelector('[data-step="under13"]'),
        contact: section.querySelector('[data-step="contact"]'),
        quiz: section.querySelector('[data-step="quiz"]'),
        result: section.querySelector('[data-step="result"]')
      };

      const els = {
        firstName: section.querySelector('[data-input-first-name]'),
        email: section.querySelector('[data-input-email]'),
        ageRange: section.querySelector('[data-input-age-range]'),
        gender: section.querySelector('[data-input-gender]'),
        consent: section.querySelector('[data-input-consent]'),
        contactError: section.querySelector('[data-contact-error]'),
        progress: section.querySelector('[data-progress]'),
        question: section.querySelector('[data-question]'),
        answers: section.querySelector('[data-answers]'),
        next: section.querySelector('[data-next-question]'),
        resultCard: section.querySelector('[data-result-card]'),
        resultGreeting: section.querySelector('[data-result-greeting]'),
        resultHouse: section.querySelector('[data-result-house]'),
        resultAnimal: section.querySelector('[data-result-animal]'),
        resultImageWrap: section.querySelector('[data-result-image-wrap]'),
        resultImage: section.querySelector('[data-result-image]'),
        resultSecondary: section.querySelector('[data-result-secondary]'),
        resultDescription: section.querySelector('[data-result-description]'),
        resultFriscoNote: section.querySelector('[data-result-frisco-note]'),
        shopLink: section.querySelector('[data-shop-link]'),
        bundleGrid: section.querySelector('[data-bundle-grid]'),
        shareFacebook: section.querySelector('[data-share-facebook]'),
        shareInstagram: section.querySelector('[data-share-instagram]'),
        downloadImage: section.querySelector('[data-download-image]'),
        copyCaption: section.querySelector('[data-copy-caption]'),
        shareModal: section.querySelector('[data-share-modal]'),
        shareModalImage: section.querySelector('[data-share-modal-image]'),
        shareModalCaption: section.querySelector('[data-share-modal-caption]'),
        shareModalDownload: section.querySelector('[data-share-modal-download]'),
        shareModalCopy: section.querySelector('[data-share-modal-copy]'),
        shareClose: section.querySelectorAll('[data-share-close]'),
        emailResultWrap: section.querySelector('[data-email-result-wrap]'),
        emailFirstName: section.querySelector('[data-email-first-name]'),
        emailAddress: section.querySelector('[data-email-address]'),
        emailTags: section.querySelector('[data-email-tags]'),
        emailPreview: section.querySelector('[data-email-preview]')
      };

      const resetScores = () => ({
        gryffindor: 0,
        ravenclaw: 0,
        hufflepuff: 0,
        slytherin: 0
      });

      const state = {
        collectData: false,
        currentQuestionIndex: 0,
        selectedAnswerIndex: null,
        scores: resetScores()
      };

      const shareState = {
        url: '',
        caption: '',
        imageUrl: '',
        filename: 'sorting-hat-cat-result.jpg'
      };

      const showStep = (stepKey) => {
        Object.entries(stepEls).forEach(([key, el]) => {
          if (!el) return;
          el.classList.toggle('mh-hidden', key !== stepKey);
        });
      };

      const restart = () => {
        state.collectData = false;
        state.currentQuestionIndex = 0;
        state.selectedAnswerIndex = null;
        state.scores = resetScores();

        if (els.contactError) {
          els.contactError.innerHTML = '';
          els.contactError.classList.add('mh-hidden');
        }

        if (els.firstName) els.firstName.value = '';
        if (els.email) els.email.value = '';
        if (els.ageRange) els.ageRange.value = '';
        if (els.gender) els.gender.value = '';
        if (els.consent) els.consent.checked = false;

        if (els.progress) els.progress.textContent = '';
        if (els.question) els.question.textContent = '';
        if (els.answers) els.answers.innerHTML = '';
        if (els.next) els.next.classList.add('mh-hidden');

        if (els.resultGreeting) els.resultGreeting.textContent = '';
        if (els.resultHouse) els.resultHouse.textContent = '';
        if (els.resultAnimal) els.resultAnimal.textContent = '';
        if (els.resultSecondary) els.resultSecondary.textContent = '';
        if (els.resultDescription) els.resultDescription.textContent = '';
        if (els.resultFriscoNote) els.resultFriscoNote.innerHTML = '';

        if (els.resultCard) {
          els.resultCard.classList.remove('is-gryffindor', 'is-ravenclaw', 'is-hufflepuff', 'is-slytherin');
        }

        if (els.resultImage) {
          els.resultImage.src = '';
          els.resultImage.alt = '';
          els.resultImage.classList.add('mh-hidden');
        }
        if (els.resultImageWrap) els.resultImageWrap.classList.add('mh-hidden');
        if (els.shopLink) els.shopLink.href = '#';
        if (els.bundleGrid) els.bundleGrid.innerHTML = '';

        if (els.emailResultWrap) els.emailResultWrap.classList.add('mh-hidden');

        showStep('age');
      };

      const renderQuestion = () => {
        const q = questions[state.currentQuestionIndex];
        state.selectedAnswerIndex = null;

        if (els.progress) {
          els.progress.textContent = `Question ${state.currentQuestionIndex + 1} of ${questions.length}`;
        }

        if (els.question) {
          els.question.textContent = q.question;
        }

        if (!els.answers) return;

        els.answers.innerHTML = '';
        if (els.next) els.next.classList.add('mh-hidden');

        q.answers.forEach((answer, index) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mh-answer';
          btn.textContent = answer.text;

          btn.addEventListener('click', () => {
            state.selectedAnswerIndex = index;
            [...els.answers.querySelectorAll('.mh-answer')].forEach((node, i) => {
              node.classList.toggle('is-selected', i === index);
            });
            if (els.next) els.next.classList.remove('mh-hidden');
          });

          els.answers.appendChild(btn);
        });
      };

      const startQuiz = (collect) => {
        state.collectData = collect;
        state.currentQuestionIndex = 0;
        state.selectedAnswerIndex = null;
        state.scores = resetScores();
        showStep('quiz');
        renderQuestion();
      };

      const nextQuestion = () => {
        if (state.selectedAnswerIndex === null) return;

        const selected = questions[state.currentQuestionIndex].answers[state.selectedAnswerIndex];
        Object.entries(selected.points).forEach(([house, points]) => {
          state.scores[house] += points;
        });

        state.currentQuestionIndex += 1;

        if (state.currentQuestionIndex < questions.length) {
          renderQuestion();
        } else {
          showResult();
        }
      };


      const buildResultLinks = (primaryKey, primaryName) => {
        const accentClass = `mh-result-link-card--${primaryKey}`;
        const primaryUrl = (config.collectionUrls && config.collectionUrls[primaryKey]) || '#';
        const allAnimalUrl = '/search?q=' + encodeURIComponent('cat OR cat-neutral');
        const allPetUrl = '/search?q=' + encodeURIComponent('dog OR dog-neutral OR cat OR cat-neutral');
        const mixedUrl = '/search?q=' + encodeURIComponent(`${primaryKey}-dog OR ${primaryKey}-cat`);
        const cards = [
          { title: `${primaryName} Cat Accessories`, url: primaryUrl },
          { title: `${primaryName} Dog & Cat Accessories`, url: mixedUrl },
          { title: `All Cat Accessories`, url: allAnimalUrl },
          { title: 'All Pet Accessories', url: allPetUrl }
        ];
        return cards.map((item) => `
          <a class="mh-result-link-card ${accentClass}" href="${item.url}">
            <span class="mh-result-link-card-kicker">Shop now</span>
            <span class="mh-result-link-card-title">${item.title}</span>
            <span class="mh-result-link-card-arrow" aria-hidden="true">→</span>
          </a>
        `).join('');
      };

      const buildShareUrl = (primaryKey) => {
        const baseUrl = `${window.location.origin}${window.location.pathname}`;
        return `${baseUrl}?share_result=${encodeURIComponent(`${primaryKey}-cat`)}`;
      };

      const buildShareCaption = (primary, secondary) => {
        const shareUrl = shareState.url || buildShareUrl(primary.key || '');
        const secondaryLine = secondary ? ` Secondary match: ${secondary.name}.` : '';
        return `My cat was sorted into ${primary.name} at The Muggle Hut!${secondaryLine}\nSee the result: ${shareUrl}\n#TheMuggleHut #${primary.name.replace(/\s+/g, '')} #HarryPotterPets #CatQuiz`;
      };

      const copyShareCaption = async () => {
        if (!shareState.caption) return;
        try {
          await navigator.clipboard.writeText(shareState.caption);
        } catch (error) {
          const fallback = document.createElement('textarea');
          fallback.value = shareState.caption;
          document.body.appendChild(fallback);
          fallback.select();
          document.execCommand('copy');
          fallback.remove();
        }
      };

      const downloadShareImage = () => {
        if (!shareState.imageUrl) return;
        const link = document.createElement('a');
        link.href = shareState.imageUrl;
        link.download = shareState.filename;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
      };

      const openShareModal = () => {
        if (!els.shareModal) return;
        if (els.shareModalImage) {
          els.shareModalImage.src = shareState.imageUrl || '';
          els.shareModalImage.alt = shareState.filename.replace(/[-_]/g, ' ');
        }
        if (els.shareModalCaption) {
          els.shareModalCaption.value = shareState.caption || '';
        }
        els.shareModal.classList.remove('mh-hidden');
        document.body.classList.add('mh-share-modal-open');
      };

      const closeShareModal = () => {
        if (!els.shareModal) return;
        els.shareModal.classList.add('mh-hidden');
        document.body.classList.remove('mh-share-modal-open');
      };

      const updateShareState = (primaryKey, primary, secondary = null) => {
        shareState.url = buildShareUrl(primaryKey);
        shareState.imageUrl = (config.resultImageUrls && config.resultImageUrls[primaryKey]) || '';
        shareState.filename = `${primaryKey}-cat-sorting-hat.jpg`;
        shareState.caption = buildShareCaption({ ...primary, key: primaryKey }, secondary);
      };

      const renderResultState = (primaryKey, secondaryKey = null, options = { shared: false }) => {
        showStep('result');

        const primary = houseResults[primaryKey];
        const secondary = secondaryKey ? houseResults[secondaryKey] : null;
        if (!primary) return;

        if (els.resultGreeting) {
          els.resultGreeting.textContent = 'The Sorting Hat has spoken:';
        }

        if (els.resultHouse) els.resultHouse.textContent = primary.name;
        if (els.resultAnimal) els.resultAnimal.textContent = 'Cat';
        if (els.resultSecondary) {
          if (secondary) {
            els.resultSecondary.innerHTML = `<span class="mh-result-secondary-primary">${primary.secondary}.</span><span class="mh-result-secondary-match">Your secondary match is ${secondary.name}.</span>`;
          } else {
            els.resultSecondary.innerHTML = `<span class="mh-result-secondary-primary">${primary.secondary}.</span>`;
          }
        }
        if (els.resultDescription) els.resultDescription.textContent = primary.description;
        if (els.shopLink) els.shopLink.href = (config.collectionUrls && config.collectionUrls[primaryKey]) || '#';

        /* Frisco pickup note preserved for future store relaunch.
        if (els.resultFriscoNote) {
          els.resultFriscoNote.innerHTML = `📍 <strong>${primary.name}</strong> picks for cats can be ordered online or picked up locally in Frisco. <a class="mh-frisco-store-link" href="/pages/frisco-harry-potter-store">Visit our Frisco store page</a>.`;
        }
        */

        if (els.bundleGrid) {
          els.bundleGrid.innerHTML = buildResultLinks(primaryKey, primary.name);
        }

        if (els.resultCard) {
          els.resultCard.classList.remove('is-gryffindor', 'is-ravenclaw', 'is-hufflepuff', 'is-slytherin');
          els.resultCard.classList.add(`is-${primaryKey}`);
        }

        if (els.resultImage && config.resultImageUrls && config.resultImageUrls[primaryKey]) {
          els.resultImage.src = config.resultImageUrls[primaryKey];
          els.resultImage.alt = `${primary.name} Cat`;
          els.resultImage.classList.remove('mh-hidden');
          els.resultImageWrap?.classList.remove('mh-hidden');
        } else {
          els.resultImage?.classList.add('mh-hidden');
          els.resultImageWrap?.classList.add('mh-hidden');
        }

        updateShareState(primaryKey, primary, secondary);

        if (state.collectData && els.emailResultWrap && !options.shared) {
          const email = (els.email && els.email.value ? els.email.value.trim() : '');
          const ageRange = (els.ageRange && els.ageRange.value ? els.ageRange.value : '');
          const gender = (els.gender && els.gender.value ? els.gender.value : '');
          const tags = ['sorting-hat', `house-${primaryKey}`];
          if (secondaryKey) tags.push(`secondary-${secondaryKey}`);

          if (ageRange) tags.push(`age-${sanitizeTagPart(ageRange)}`);
          if (gender) tags.push(`gender-${sanitizeTagPart(gender)}`);

          if (els.emailTags) els.emailTags.value = tags.join(',');
          if (els.emailFirstName) els.emailFirstName.value = (els.firstName?.value || '').trim();
          if (els.emailAddress) els.emailAddress.value = email;
          if (els.emailPreview) els.emailPreview.textContent = email || 'your email address';

          els.emailResultWrap.classList.remove('mh-hidden');
        } else if (els.emailResultWrap) {
          els.emailResultWrap.classList.add('mh-hidden');
        }
      };

      const showResult = () => {
        const ranked = Object.keys(state.scores).sort((a, b) => state.scores[b] - state.scores[a]);
        renderResultState(ranked[0], ranked[1]);
      };

      const shareParams = new URLSearchParams(window.location.search);
      const sharedResultValue = (shareParams.get('share_result') || '').toLowerCase();
      const showSharedResultIfPresent = () => {
        const pieces = sharedResultValue.split('-');
        if (pieces.length !== 2) return false;
        const [houseKey, animalKey] = pieces;
        if (animalKey !== 'cat' || !houseResults[houseKey]) return false;
        state.collectData = false;
        renderResultState(houseKey, null, { shared: true });
        return true;
      };
      section.querySelectorAll('[data-age-gate]').forEach((btn) => {
        btn.addEventListener('click', () => showStep(btn.dataset.ageGate === 'yes' ? 'contact' : 'under13'));
      });

      section.querySelector('[data-start-under13]')?.addEventListener('click', () => startQuiz(false));

      section.querySelector('[data-begin-quiz]')?.addEventListener('click', () => {
        const errors = [];
        const firstName = els.firstName?.value.trim() || '';
        const email = els.email?.value.trim() || '';
        const consent = !!els.consent?.checked;

        if (!firstName) errors.push('Please enter your first name.');
        if (!email) errors.push('Please enter your email address.');
        else if (!validateEmail(email)) errors.push('Please enter a valid email address.');
        if (!consent) errors.push('Please check the consent box to continue.');

        if (errors.length) {
          if (els.contactError) {
            els.contactError.innerHTML = errors.join('<br>');
            els.contactError.classList.remove('mh-hidden');
          }
          return;
        }

        if (els.contactError) els.contactError.classList.add('mh-hidden');
        startQuiz(true);
      });

      section.querySelectorAll('[data-restart]').forEach((btn) => btn.addEventListener('click', () => {
        const cleanUrl = `${window.location.origin}${window.location.pathname}`;
        window.history.replaceState({}, '', cleanUrl);
        closeShareModal();
        restart();
      }));
      els.next?.addEventListener('click', nextQuestion);

      els.shareFacebook?.addEventListener('click', () => {
        if (!shareState.url) return;
        const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareState.url)}`;
        window.open(facebookShareUrl, '_blank', 'noopener,noreferrer,width=626,height=436');
      });
      els.shareInstagram?.addEventListener('click', openShareModal);
      els.downloadImage?.addEventListener('click', downloadShareImage);
      els.copyCaption?.addEventListener('click', copyShareCaption);
      els.shareModalDownload?.addEventListener('click', downloadShareImage);
      els.shareModalCopy?.addEventListener('click', copyShareCaption);
      els.shareClose?.forEach((btn) => btn.addEventListener('click', closeShareModal));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && els.shareModal && !els.shareModal.classList.contains('mh-hidden')) {
          closeShareModal();
        }
      });

      if (!showSharedResultIfPresent()) {
        restart();
      }
    }

    function initAllSortingSections() {
      document.querySelectorAll('.mh-sorting-section').forEach(initSortingSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllSortingSections);
    } else {
      initAllSortingSections();
    }
    window.addEventListener('load', initAllSortingSections);

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (!target) return;
      target.querySelectorAll('.mh-sorting-section').forEach(initSortingSection);
      if (target.matches && target.matches('.mh-sorting-section')) initSortingSection(target);
    });
  })();
